export function articleEquipment() {
	$(".equipment-slider").each(function() {
		const sliderWrapItem = $(this);
		const slider = sliderWrapItem.find(".slides");

		slider.slick({
			infinite: false,
			variableWidth: true,
			appendArrows: '.equipment-slider-control',
			arrows: true,
			prevArrow:'<button class="slick-prev"><svg  viewBox="0 0 18 16"><path d="M8 1L1 8M1 8L8 15M1 8L17 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
			nextArrow:'<button class="slick-next"><svg viewBox="0 0 18 16"><path d="M10 1L17 8M17 8L10 15M17 8L1 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
		});
	});
}



// WEBPACK FOOTER //
// ./assets/js/modules/articleEquipment.js